// PageCover.js
import React from 'react';
import './pageCover.css';

const PageCover = ({
    reportTitle,
    reportSubtitle,
    tagline,
    footerLines,
    variant,
    orgName,
    orgRole,
    year,
    orgLogo,
    general = true,
}) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/portada.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    };

    function capitalizeSentence(text) {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    // Calcula tamaño dinámico de fuente según longitud del subtítulo.
    // Base: 56px (<=20 chars). Se reduce gradualmente hasta un mínimo de 24px.
    const computeSubtitleFontSize = (text) => {
        if (!text) return 56;
        const len = text.length;
        if (len <= 20) return 56;
        if (len <= 30) return 48;
        if (len <= 40) return 40;
        if (len <= 55) return 32;
        if (len <= 70) return 28;
        return 24; // extremadamente largo
    };

    const subtitleFontSize = computeSubtitleFontSize(reportSubtitle);

    const isSelfcare360 = variant === 'selfcare360';


    return (
        <div className="pdf-page cover-page" style={backgroundStyle}>
            <span className='cover-title'>{reportTitle}</span>
            <div className='cover-subtitle'>
                <span style={{ fontSize: subtitleFontSize }}>{reportSubtitle}</span>
            </div>
            {tagline && (
                <div className={isSelfcare360 ? 'cover-tagline-selfcare360' : 'cover-tagline'}>
                    {tagline}
                </div>
            )}
            <img src={orgLogo} className='cover-company-logo' alt="Logo organización" />
            <div className="cover-year-stack">
                {[...year.toString()].map((digit, index) => (
                    <div key={index}>{digit}</div>
                ))}
            </div>
            {
                !general && <div className={isSelfcare360 ? 'cover-company-employee-data cover-company-employee-data-selfcare360' : 'cover-company-employee-data'}>
                    <span className='name'>{orgName}</span>
                    <span className='role'>{capitalizeSentence(orgRole)}</span>
                </div>
            }

            {Array.isArray(footerLines) && footerLines.length > 0 && (
                <div className={isSelfcare360 ? 'cover-footer-selfcare360' : 'cover-footer'}>
                    {footerLines.map((line, index) => (
                        <div key={index}>{line}</div>
                    ))}
                </div>
            )}
        </div>
    );
};


export default PageCover;
